import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { apiPost } from '../services/api';
import './Login.css';

export default function Login() {
  const { setAuth } = useContext(AuthContext);
  const [form, setForm]   = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await apiPost('/auth/login', form);
      setAuth(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-root">
      <div className="login-bg">
        <div className="login-bg-grid" />
        <div className="login-bg-glow" />
      </div>

      <div className="login-card">
        <div className="login-logo">
          <div className="login-brand">
            <span className="login-brand-name">
              <span className="login-brand-g">g</span>estavin
            </span>
            <span className="login-brand-sub">crm · modular · saas</span>
          </div>
        </div>

        <h1 className="login-title">Bienvenido/a</h1>
        <p className="login-subtitle">Accede a tu panel de gestión</p>

        <form onSubmit={submit} className="login-form">
          <div className="login-field">
            <label>Email</label>
            <div className="login-input-wrap">
              <svg className="login-input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
              </svg>
              <input
                type="email"
                name="email"
                placeholder="tu@email.com"
                value={form.email}
                onChange={handle}
                required
              />
            </div>
          </div>

          <div className="login-field">
            <label>Contraseña</label>
            <div className="login-input-wrap">
              <svg className="login-input-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
              </svg>
              <input
                type="password"
                name="password"
                placeholder="••••••••"
                value={form.password}
                onChange={handle}
                required
              />
            </div>
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? <span className="login-spinner"/> : 'Entrar'}
          </button>
        </form>

        <p className="login-footer">¿Problemas para acceder? Contacta con tu administrador.</p>
        <p className="login-privacy">
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Política de privacidad</a>
          {' · '}
          <a href="/terms" target="_blank" rel="noopener noreferrer">Condiciones de uso</a>
          {' · '}
          <a href="/data-deletion" target="_blank" rel="noopener noreferrer">Eliminación de datos</a>
        </p>
        <p className="login-by">By OriginIA</p>
      </div>
    </div>
  );
}
